var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_home_icon",
    transform: "translate(-12 -121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14122",
    "data-name": "Rectangle 14122",
    transform: "translate(12 121)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "menu_1_",
    "data-name": "menu (1)",
    transform: "translate(16 65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22666",
    "data-name": "Group 22666",
    transform: "translate(0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22665",
    "data-name": "Group 22665"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14123",
    "data-name": "Rectangle 14123",
    width: 26,
    height: 2.889,
    transform: "translate(0 15.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14124",
    "data-name": "Rectangle 14124",
    width: 26,
    height: 2.889,
    transform: "translate(0 7.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14125",
    "data-name": "Rectangle 14125",
    width: 26,
    height: 2.889,
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHomeIcon);
export default __webpack_public_path__ + "static/media/menu_home_icon.ed093fea8d47b35d3eff0085fa54f4f5.svg";
export { ForwardRef as ReactComponent };